import { Button, Col, Typography } from "antd";
import React from "react";
import { InputSelect } from "../../../../shared/components";
import { useCreateProduct2x1 } from "../../hooks";
import { useProducts } from "../../../products";
import { useParams } from "react-router-dom";

const { Text } = Typography;
export const Product2x1Form = ({
  setOpenModalCreate,
}: {
  setOpenModalCreate: (val: boolean) => void;
}) => {
  const { rule_id } = useParams();
  const { control, handleSubmit } = useCreateProduct2x1({
    setOpenModalCreate,
    rule_id: +rule_id!,
  });
  const { productsPremiun, findAllProductsPremium } = useProducts();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    findAllProductsPremium();
  }, []);
  return (
    <form onSubmit={handleSubmit}>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Text style={{ marginBottom: "1.5px" }}>Producto:</Text>
        <InputSelect
          label="Selecciona el producto que se va a listar como 2x1"
          name="product_id"
          control={control}
          dataOptions={productsPremiun.map((item) => ({
            title: item.name,
            value: item.id.toString(),
          }))}
        />
      </Col>
      <Button
        htmlType="submit"
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
      >
        Crear
      </Button>
    </form>
  );
};
